import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import legSrc from '@cover/weiterzoomen/leg.svg';
import tailSrc from '@cover/weiterzoomen/tail.svg';
import chatLeftSrc from '@cover/weiterzoomen/chat-1.svg';
import chatRightSrc from '@cover/weiterzoomen/chat-2.svg';

const AnimatedLayer = styled.img`
	position: absolute;
`

const Leg = styled(AnimatedLayer)`
	height: 29%;
	top: 50.5%;
	left: 36.5%;
	transform-origin: top left;
`
const Tail = styled(AnimatedLayer)`
	height: 11%;
	top: 32.1%;
	right: 35%;
	transform-origin: 70% 94%;
	z-index: 999;
`
const ChatLeft = styled(AnimatedLayer)`
	height: 4.5%;
	top: 11%;
	left: 5.5%;
	transform-origin: center center;
	opacity: 0;
`
const ChatRight = styled(AnimatedLayer)`
	height: 4.5%;
	top: 17.5%;
	right: 5.5%;
	transform-origin: center center;
	opacity: 0;
`

const WeiterZoomen = ({ play }) => {
	const leg = useRef(false);
	const tail = useRef(false);
	const chatLeft = useRef(false);
	const chatRight = useRef(false);

	useEffect(() => {
		const timeline = anime.timeline({
			autoplay: play,
			loop: true,
			direction: 'alternate'
		});

		timeline
		.add({
			targets: chatLeft.current,
			loop: true,
			duration: 3000,
			delay: 800,
			keyframes: [
				{opacity: 1, scale: 2, easing: 'easeInOutElastic(1, .6)', duration: 350},
				{scale: 1.8, rotate: 2, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: 1, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: 2, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: -1, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: -2, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: 1, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1, opacity: 0, easing: 'easeInOutElastic(1, .6)', duration: 350}
			]
		})
		.add({
			targets: chatRight.current,
			loop: true,
			duration: 2000,
			keyframes: [
				{opacity: 1, scale: 2, easing: 'easeInOutElastic(1, .6)', duration: 350},
				{scale: 1.8, rotate: 1, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: 2, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: 1, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: -2, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1.8, rotate: -1, easing: 'easeInSine'},
				{scale: 2, rotate: 0, easing: 'easeInSine'},
				{scale: 1, opacity: 0, easing: 'easeInOutElastic(1, .6)', duration: 350, endDelay: 800}
			]
		}, '-=1600');

		anime({
			targets: leg.current,
			autoplay: play,
			loop: true,
			endDelay: 1000,
			keyframes: [
				{rotate: -5, duration: 250, easing: 'easeInSine'},
				{rotate: 0, duration: 250, easing: 'spring(1, 80, 10, 0)'},
				{rotate: -4, duration: 250, easing: 'easeInSine'},
				{rotate: 0, duration: 250, easing: 'spring(1, 80, 10, 0)'},
				{rotate: -2, duration: 250, easing: 'easeInSine'},
				{rotate: 0, duration: 250, easing: 'spring(1, 80, 10, 0)'},
			],
		});

		anime({
			targets: tail.current,
			autoplay: play,
			loop: true,
			delay: 2000,
			keyframes: [
				{rotate: -10, duration: 250, easing: 'easeInSine'},
				{rotate: 0, duration: 250, easing: 'spring(1, 80, 10, 0)'},
				{rotate: -10, duration: 250, easing: 'easeInSine'},
				{rotate: 0, duration: 250, easing: 'spring(1, 80, 10, 0)', endDelay: 1500},
				{rotate: -10, duration: 250, easing: 'easeInSine'},
				{rotate: 0, duration: 250, easing: 'spring(1, 80, 10, 0)', endDelay: 1500},
			],
		});
	}, [play])
	return (
		<>
			<Leg src={legSrc} ref={leg} />
			<Tail src={tailSrc} ref={tail} />
			<ChatLeft src={chatLeftSrc} ref={chatLeft} />
			<ChatRight src={chatRightSrc} ref={chatRight} />
		</>
	)
};

export default WeiterZoomen;